import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import NurturingYoungMinds from "./sections/NurturingYoungMinds";
import TheSureSuccessExperience from "./sections/TheSureSuccessExperience";
import WhyFamiliesLoveUs from "./sections/WhyFamiliesLoveUs";
import PathToSuccess from "./sections/PathToSuccess";
import TheArchitects from "./sections/TheArchitects";
import HappyTailsTales from "./sections/HappyTailsTales";
import ReadyToFly from "./sections/ReadyToFly";
import TheFoundationFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <NurturingYoungMinds />
      <TheSureSuccessExperience />
      <WhyFamiliesLoveUs />
      <PathToSuccess />
      <TheArchitects />
      <HappyTailsTales />
      <ReadyToFly />
      <TheFoundationFooter />
    </div>;
}